<template>
  <div :class="$style.homeLogo">
    <img src="@/assets/img/LOGO@2x.png"
         alt="Burger Boss">
  </div>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';

@Component({
  name: 'Logo',
})
export default class Logo extends Vue {

}
</script>

<style lang="scss" module>

  .homeLogo {
    img {
      max-width: 100%;
      height: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Logo.vue